import _classCallCheck from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Wrapper } from '../basic';
import { Text } from './';
import { LoadingImage } from '..';
export var LocalizeLoading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocalizeLoading, _React$Component);

  function LocalizeLoading() {
    _classCallCheck(this, LocalizeLoading);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalizeLoading).apply(this, arguments));
  }

  _createClass(LocalizeLoading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          wrapper = _this$props.wrapper;
      return React.createElement(Wrapper, {
        element: wrapper
      }, text || React.createElement(Text, {
        id: "loading"
      }), "... ", React.createElement(LoadingImage, null));
    }
  }]);

  return LocalizeLoading;
}(React.Component);